import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { MemberSocket } from "modules/api/websockets";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { create } from "zustand";
import { endSession, getSubdomain, logout, refresh } from "../api";

type MemberAuthStore = {
  isSignedin: boolean;
  subdomain: string;
  accessToken?: string;
  id?: string;
  orgId?: string;
};
const signedin = localStorage.getItem("memSignedIn") === "true";

export const useMemberAuthStore = create<MemberAuthStore>()((set, get) => ({
  isSignedin: signedin,
  subdomain: getSubdomain(),
}));

export const useMemberOrgId = () => {
  return useMemberAuthStore((state) => state.orgId);
};

export const useMemberSignedIn = () => {
  const signedin = useMemberAuthStore((state) => state.isSignedin);
  useEffect(() => {
    refresh();
  }, []);
  return signedin;
};

// Everything signed-in keys off `accessToken`, and logout revokes it
// server-side, so it has to go synchronously: a stale token keeps every member
// query enabled, they 401, and the route error boundary takes the page down.
export const signOutMember = (queryClient: QueryClient) => {
  endSession();
  useMemberAuthStore.setState({
    isSignedin: false,
    accessToken: undefined,
    id: undefined,
    orgId: undefined,
  });
  localStorage.removeItem("memSignedIn");
  MemberSocket.close();
  queryClient.clear();
  return logout().catch(() => null);
};

export const useMemberLogout = () => {
  const nav = useNavigate();
  const queryClient = useQueryClient();
  const onLogout = () => {
    signOutMember(queryClient);
    nav("/members/auth/sign-in");
  };

  return onLogout;
};
